awardCalculation.classy.controller({
    name: 'AwardCalculationController',
    inject: ['$scope', '$http', '$location', '$rootScope', 'RestService', '$stateParams',
        'ApplicationSideBarService', 'ApplicationService', 'CalculationService', '$timeout', 'SliderService',
        'ResetService', 'PulsateService', 'TabsService', 'SchoolModelService'],
    init: function ()
    {
        this.$.$location = this.$location;
        this.$.stateParams = this.$stateParams;
        this.$.ApplicationSideBarService = this.ApplicationSideBarService;
        this.$.ApplicationService = this.ApplicationService;
        this.$.CalculationService = this.CalculationService;
        this.$.ResetService = this.ResetService;
        this.$.PulsateService = this.PulsateService;
        this.$.schoolinfo = this.SchoolModelService.get()[0];
        this.$.activeDiv = "reportedIncome";
        this.$.versionNo = versionNo;
        this.$.TabsService = this.TabsService;
        this.$.awardType = 0;
        this.$.SliderService = this.SliderService;
    },
    toggleBoolean: function (field)
    {
        this.$[field] = !this.$[field];
    },
    setAwardRejectTrue: function (field, type)
    {
        //Close already open div
        if (this.$[field] == true && this.$.awardType == type) {
        }
        else if ((this.$[field] == true && this.$.awardType != type) || (this.$[field] == false)) //Switch award types gracefully
        {
            this.TabsService.setActiveDiv('recommendedAward');
            var self = this;
            this.$timeout(function () {
                self.$[field] = true;
                self.$.awardType = type;
            }, 300);
        }
    }

});


stateProviders.push({
    abstract: true,
    name: 'schoolside.application.awardCalculation',
    url: '/awardCalculation',
    templateUrl: 'fast/submodules/schoolside/applications/mainContent/tabs/awardCalculation/awardCalculation.html?v=' + versionNo,
    controller: 'AwardCalculationController'
});



/* End accountInfo Module */
